import { Entity, Field } from '@adornis/baseql/decorators';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { SizeController } from '@adornis/chemistry/controllers/size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-grid';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/wtg-blog-post-preview.js';
import '../components/wtg-event-card';
import '../components/wtg-footer';

@Entity()
export class WTGEvent extends AdornisEntity {
  public static override _class = 'WTGEvent';

  @Field(type => String)
  public coverImageID?: string;

  @Field(type => String)
  @validate(nonOptional())
  public title!: string;

  @Field(type => String)
  public orgName?: string;

  @Field(type => String)
  public orgImageID?: string;

  @Field(type => String)
  public location?: string;

  @Field(type => String)
  public href?: string;
}

const events = [
  new WTGEvent({
    title: 'Get to know us',
    location: 'Frankfurt 24/05/23, 9am till 2pm',
    href: 'https://goetheunibator.de/unibator-info/unibator-meetup/',
    orgName: 'Goethe University',
    orgImageID: require('client/assets/events/unibator-logo.jpeg'),
    coverImageID: require('client/assets/events/event-unibator-meetup.jpeg'),
  }),
  new WTGEvent({
    title: 'Latinoamericanos en Alemania',
    location: 'Frankfurt 06/06/23, 6pm till 9pm',
    href: 'https://www.eventbrite.com/e/emprendedores-latinos-en-alemania-y-el-panorama-actual-tickets-639302128877',
    orgName: 'Goethe University',
    orgImageID: require('client/assets/events/unibator-logo.jpeg'),
    coverImageID: require('client/assets/events/event-second.jpeg'),
  }),
];

/**
 * @element wtg-events
 */
@customElement('wtg-events')
export class WTGEvents extends ChemistryLitElement {
  s = new SizeController(this);

  override render() {
    return html`
      <x-flex space="xl">
        <ge-section ${css({ padding: `200px 0 ${this.spacing.xxl} 0`, background: '#F4EEF5', position: 'relative' })}>
          <x-flex space="lg" ${css({ maxWidth: this.sizes.maxReadableWidth })}>
            <ge-h1> Amazing Events </ge-h1>
            <ge-text> Find the best plans to make and discover all the news. </ge-text>
          </x-flex>
          ${!this.s.isMobile
            ? html`
                <x-image
                  .value=${require('client/assets/events.png')}
                  ${css({ position: 'absolute', top: '-70px', right: '0', bottom: '-4.5%' })}
                  mode="height"
                ></x-image>
              `
            : nothing}
        </ge-section>
        <ge-section>
          <x-grid auto-fill-columns="300px" space="lg">
            ${events.map(
              event => html`
                <wtg-event-card
                  cover-img=${event.coverImageID}
                  title=${event.title}
                  org-name=${event.orgName}
                  org-img=${event.orgImageID}
                  location=${event.location}
                  href=${event.href}
                ></wtg-event-card>
              `,
            )}
          </x-grid>
        </ge-section>
        <wtg-footer></wtg-footer>
      </x-flex>
    `;
  }
}
